import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as minimaleEisenPerInfrastructuurActions from "../../actions/minimaleEisenPerInfrastructuurActions";
import * as infrastructuurActions from "../../actions/infrastructuurActions";
import * as layoutActions from "../../actions/layoutActions";
import * as documentActions from "../../actions/documentActions";

import AutoBindComponent from "../common/AutoBindComponent";
import * as types from "../../constants/ComponentConstants";

import MinimaleEisenPerInfrastructuurForm from "./MinimaleEisenPerInfrastructuurForm";
import MinimaleEisenPerInfrastructuurPageHelper from "./MinimaleEisenPerInfrastructuurPageHelper";

import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";

import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import EasterEggHandler from "../common/EasterEggHandler";
import * as pageConstants from "../../constants/EasterEggConstants";

class MinimaleEisenPerInfrastructuurPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			requestedId: null,
			titleSet: false,
			fileSessionStarted: false,
			hasUnsavedChanges: false,
			sjablonen: [],
			aftrekbaar: [
				{ value: true, label: 'ja' },
				{ value: false, label: 'nee' }
			],
			algemeenTotaal: 0
		};

		this.pageHelper = new MinimaleEisenPerInfrastructuurPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.MINIMALEEISENINFRASTRUCTUUR);
	}

	componentWillReceiveProps(nextProps) {
		this.pageHelper.update(nextProps);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	handleOnChange(event, data) {
		this.pageHelper.onChange(event, data);
	}

	handleOnChangeDateNVT(event, dateField) {
		this.pageHelper.onChangeDateNVT(event, dateField);
	}

	handleOnCopyMijlpalen(infrastructuurIdToCopyFrom) {
		this.pageHelper.onCopyMijlpalen(infrastructuurIdToCopyFrom);
	}

	handleOnDropFiles(component, files) {
		this.pageHelper.onDropFiles(component, files);
	}

	handleOnDeleteFile(component, fileName) {
		this.pageHelper.onDeleteFile(component, fileName);
	}

	handleOnSave(event) {
		this.pageHelper.onSave(event);
	}

	componentDidMount() {
		this.easterEggHandler.bind();
	}

	componentWillUnmount() {
		this.easterEggHandler.unbind();
	}

	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.state.minimaleEisenPerInfrastructuur) {
			return false;
		}

		return true;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}
		const validationMessageType = this.state.validationMessageType;

		return (
			<div>
				<MinimaleEisenPerInfrastructuurForm
					minimaleEisen={this.state.minimaleEisenPerInfrastructuur}
					documenten={this.state.documenten}
					langdurigZakelijkRechtTypes={this.props.langdurigZakelijkRechtTypes}
					stedenbouwkundigeBestemmingen={this.props.stedenbouwkundigeBestemmingen}
					infrastructuur={this.props.infrastructuur}
					dossierType={this.state.minimaleEisenPerInfrastructuur.typeDossier}
					disabled={this.props.disabled}
					fileTypes={this.props.fileTypes}
					errors={this.state.errors}
					onChange={this.handleOnChange}
					onChangeDateNVT={this.handleOnChangeDateNVT}
					onCopyMijlpalen={this.handleOnCopyMijlpalen}
					onDropFiles={this.handleOnDropFiles}
					onDeleteFile={this.handleOnDeleteFile}
					onSave={this.handleOnSave}
					color={types.COLOR_GREEN_LIGHT}
					fileSessionStarted={this.state.fileSessionStarted}
					otherInfrastructuren={this.props.otherInfrastructuren}
					sjablonen={this.state.sjablonen}
					standVanZakenMER={this.props.standVanZakenMER}
					validationMessageType={validationMessageType}
				/>
			</div>
		);
	}
}

// ----------------------------------------------------------------------------
function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const infrastructuurId = ownProps.params.infrastructuurId !== undefined && ownProps.params.infrastructuurId !== null ? ownProps.params.infrastructuurId : state.infrastructuren[0].id;
	const minimaleEisenPerInfrastructuur = state.minimaleEisenPerInfrastructuur;
	const infrastructuur = state.infrastructuren.find(e => e.id === infrastructuurId);
	const disabled = state.ajaxCounter > 0 || state.settings.lockAllDossiers || ((minimaleEisenPerInfrastructuur.item) && minimaleEisenPerInfrastructuur.item.redenVanStatus == 121450000);

	return {
		disabled: disabled,
		minimaleEisenPerInfrastructuur: minimaleEisenPerInfrastructuur.item,
		dossierId: dossierId,
		infrastructuurId: infrastructuurId,
		errors: minimaleEisenPerInfrastructuur.errors,
		validationMessageType: minimaleEisenPerInfrastructuur.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING,
		hasValidationErrors: minimaleEisenPerInfrastructuur.hasValidationErrors,
		infrastructuur: infrastructuur,
		fileTypes: state.settings.fileTypes,
		langdurigZakelijkRechtTypes: state.referentie.zakelijkRechtPerJaarTypes,
		stedenbouwkundigeBestemmingen: convertToLabelValuePair(state.referentie.stedenbouwkundigeBestemmingen),
		otherInfrastructuren: state.infrastructuren.filter(x => x.id !== infrastructuurId),
		standVanZakenMER: convertToLabelValuePair(state.referentie.standVanZakenMER)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		saveMinimaleEisenPerInfrastructuur: bindActionCreators(minimaleEisenPerInfrastructuurActions.saveMinimaleEisenPerInfrastructuur, dispatch),
		loadMinimaleEisenPerInfrastructuur: bindActionCreators(minimaleEisenPerInfrastructuurActions.loadMinimaleEisenPerInfrastructuur, dispatch),
		getMinimaleEisenPerInfrastructuur: bindActionCreators(minimaleEisenPerInfrastructuurActions.getMinimaleEisenPerInfrastructuur, dispatch),
		loadInfrastructurenByDossierId: bindActionCreators(infrastructuurActions.loadInfrastructurenByDossierId, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadMinimaleEisenInfrastructuurPageLayout, dispatch),
		uploadDocument: bindActionCreators(documentActions.uploadInfrastructuurDocument, dispatch),
		deleteDocument: bindActionCreators(documentActions.deleteInfrastructuurDocument, dispatch),
		startFileSession: bindActionCreators(documentActions.startInfrastructuurFileSession, dispatch),
		endFileSession: bindActionCreators(documentActions.endInfrastructuurFileSession, dispatch),
		getContent: bindActionCreators(documentActions.getInfrastructuurContent, dispatch),
		getSjablonen: bindActionCreators(documentActions.getSjablonen, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(MinimaleEisenPerInfrastructuurPage));
